import { Component, Input } from '@angular/core';
import { ITableCellItem } from "../../../../../shared/shared/table/table-cell";
import { ITableColumn } from "../../../../../shared/shared/table/table-column";
import { IDocumentDto } from "../../../dto/document-listing.dto";
import { DocumentTypeEnum } from 'app/main/pages/templates/template.dto';
import { TranslocoService } from '@jsverse/transloco';
import { DocumentInternalReminder } from '../../../dto/document-details.dto';
import {
    getReminderDateText,
    getReminderMessageText,
    getReminderUsersText,
    getReminders,
    hasReminder,
    isReminderExpired
} from '../../../utils/document-reminder.utils';

@Component({
    selector: 'app-document-column',
    templateUrl: './document-column.component.html',
    styleUrl: './document-column.component.scss'
})
export class DocumentColumnComponent implements ITableCellItem {

    @Input() dataItem: IDocumentDto;
    constructor(private translocoService: TranslocoService) { }
    public columnOptions: ITableColumn;
    public documentTypeEnum = DocumentTypeEnum;

    get documentType():string{
        return this.dataItem?.document_type?.document_type || "";
    }

    get documentFormat(): string {
        const keyMap = {
            [DocumentTypeEnum.REGULAR]: 'Document type setting - modal - Document Preview setting (Document type section) - Signature request',
            [DocumentTypeEnum.TEMPLATEDOCUMENT]: 'Document listview document icon tooltip (documents) - Document',
            [DocumentTypeEnum.PDF]: 'Document listview PDF file icon tooltip (documents) - PDF file',
            [DocumentTypeEnum.EXCEL]: 'Document listview Excel file icon tooltip (documents) - Excel file',
            [DocumentTypeEnum.WORD]: 'Document listview Docx file icon tooltip (documents) - Docx file',
        };
        const translationKey = keyMap[this.dataItem?.type];
        return translationKey ? this.translocoService.translate(translationKey) : '';
    }

    hasReminder(item: IDocumentDto = this.dataItem): boolean {
        return hasReminder(item);
    }

    isReminderExpired(item: IDocumentDto = this.dataItem): boolean {
        return isReminderExpired(item);
    }

    getReminders(item: IDocumentDto = this.dataItem): DocumentInternalReminder[] {
        return getReminders(item);
    }

    getReminderUsersText(reminder: DocumentInternalReminder): string {
        return getReminderUsersText(reminder);
    }

    getReminderMessageText(reminder: DocumentInternalReminder): string {
        return getReminderMessageText(reminder);
    }

    getReminderDateText(reminder: DocumentInternalReminder): string {
        return getReminderDateText(reminder, this.translocoService.getActiveLang());
    }

}
